import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { CircularProgress } from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';

export default function OrderListPdfDownloadButton({
	pedidos = [],
	tipo = 'Pedidos',
	children = 'Descargar PDF',
	...buttonAttrs
}) {
	const [loading, setLoading] = useState(false);

	const handleDownloadPDF = async () => {
		if (!pedidos || pedidos.length === 0) {
			alert('No hay pedidos para descargar');
			return;
		}

		try {
			setLoading(true);

			const timestamp = Date.now();
			const currentDate = new Date().toLocaleDateString('es-ES', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

			const headers = ['ID', 'Fecha', 'Cliente', 'País', 'Total'];

			const products = pedidos.map((pedido) => [
				pedido.ID?.toString() || '',
				pedido.UNIXDATE
					? moment.unix(pedido.UNIXDATE).format('DD/MM/YYYY HH:mm')
					: '',
				pedido.SHIPMENT?.NOMBRECOMERCIAL || '',
				pedido.SHIPMENT?.PAIS || '',
				pedido.TOTAL_PRICE || '0.00€',
			]);

			const requestData = {
				templateName: 'list',
				data: {
					title: `Listado de ${tipo}`,
					subtitle: `Generado el ${currentDate} - Total: ${pedidos.length} pedidos`,
					headers: headers,
					data: products,
				},
				fileName: `${tipo.toLowerCase()}_${timestamp}.pdf`,
			};

			const response = await axios.post('/api/pdf/generate', requestData, {
				responseType: 'blob',
				withCredentials: true,
			});

			if (!response.success) {
				throw new Error('Error al generar el PDF');
			}

			const blob = new Blob([response.data], { type: 'application/pdf' });
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error al generar PDF:', error.message);
			if (error.code === 'ECONNABORTED') {
				alert(
					'Tiempo de espera agotado. El PDF no se pudo generar. Intenta de nuevo.'
				);
			} else {
				alert(
					'No se pudo generar el PDF. Por favor, intenta de nuevo más tarde.'
				);
			}
		} finally {
			setLoading(false);
		}
	};

	const isDisabled = !pedidos || pedidos.length === 0 || loading;

	buttonAttrs = {
		color: 'primary',
		variant: 'contained',
		startIcon: loading ? <CircularProgress size={'1rem'} /> : <GetAppIcon />,
		...buttonAttrs,
	};

	return (
		<Button {...buttonAttrs} onClick={handleDownloadPDF} disabled={isDisabled}>
			{loading ? 'Generando PDF...' : children}
		</Button>
	);
}
